import React from "react";
import { Navigate } from "react-router-dom";
import Cookies from "js-cookie";

const ProtectedRoute = ({ element: Component }) => {
  const token = Cookies.get("kalista-webtoken");

  return token ? Component : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
